module.exports = __webpack_public_path__ + "img/netCelebritySJ.d8956bcb.png";